import analyticsService from '@razorpay/universe-utils/analytics';

import analytics from '.';
import { getQueryParam } from '@/api/helper';
import { PaymentFetchResponse } from '@/api/types';
import { USER_TYPE } from '@/constants';

/**
 * Helper function set meta of analytics events to be sent in all events
 * @param data
 */
export const updatePaymentDataInAnalytics = (data?: PaymentFetchResponse): void => {
  analytics.setMeta('payment_id', getQueryParam('id') as string);
  analytics.setMeta('source', 'std-checkout');
  if (data) {
    analytics.setMeta('merchant_id', data.gateway_merchant?.id);
    analytics.setMeta('amount', data.amount);
    analytics.setMeta('user_id', data.contact.mobile);
  }
};

export const getUserLoggedInStatus = (token: string | null, userContact = ''): string => {
  return Boolean(token && userContact) ? USER_TYPE.LOGGED_IN : USER_TYPE.NON_LOGGED_IN;
};

export const trackHelper = (data: analyticsService.TrackProps): void => {
  try {
    analytics.track(data);
  } catch (error: unknown) {
    // empty catch
  }
};
